import Api from 'services/apiService.js';
import {
  START_OR_RESUME_SURVEY,
  COMMIT_QUESTION_BLOCK,
  GET_BLOCK,
  SUBMIT_ANSWER,
} from 'actionTypes';

const surveySlug = process.env.REACT_APP_SURVEY_SLUG;

function commitQuestionBlockEndpoint(endpointArgs) {
  const { blockId } = endpointArgs;
  return `surveys/${surveySlug}/blocks/${blockId}/commit`;
}

function getBlockEndpoint(endpointArgs) {
  const { blockId } = endpointArgs;
  return `surveys/${surveySlug}/blocks/${blockId}`;
}

function submitAnswerEndpoint(endpointArgs) {
  const { questionId } = endpointArgs;
  return `surveys/${surveySlug}/answers/${questionId}`;
}

export default {
  [START_OR_RESUME_SURVEY]: {
    endpoint: `surveys/${surveySlug}/questions/current`,
    apiFunc: Api.get,
  },
  [COMMIT_QUESTION_BLOCK]: {
    endpoint: commitQuestionBlockEndpoint,
    apiFunc: Api.post,
  },
  [GET_BLOCK]: {
    endpoint: getBlockEndpoint,
    apiFunc: Api.get,
  },
  [SUBMIT_ANSWER]: {
    endpoint: submitAnswerEndpoint,
    apiFunc: Api.put,
  },
};



// WEBPACK FOOTER //
// ./src/endpoints/surveyEndpoints.js